import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { mapValidationFieldsToClassName } from '../../forms/inputValidations';
import NatureOfSuitTooltip from '../tooltips/NatureOfSuitTooltip';
import './NatureOfSuitOfAppellete.less';

class NatureOfSuitOfAppellete extends Component {
  map2Options(mapOfOptions) {
    return Object.keys(mapOfOptions).map(instance => ({
      value: instance,
      label: mapOfOptions[instance]
    }))
  }

  render() {
    return (
      <div className="nature-of-suit-selector-container">
        <label
          style={{ fontWeight: 700 }}
          className="nature-of-suit-selector-label"
          htmlFor="nature-of-suit-selector">Nature of Suit: </label><br/>
        <div className={`nature-of-suit-selector ${this.props.className}`}>
          <Select
            name="nature-of-suit-field-name"
            options={this.map2Options(natureOfSuitOptions)}
            multi={true}
            simpleValue={true}
            value={this.props.filters.get('nos')}
            placeholder="Select..."
            onChange={(nos) => this.props.onChange({ nos: nos || '' })}/>
        </div>
        <NatureOfSuitTooltip/>
      </div>
    )
  }
}

NatureOfSuitOfAppellete.propTypes = {
  onChange: PropTypes.func,
};

NatureOfSuitOfAppellete.defaultProps = {
  onChange: () => {
  }
};


export default connect(state => mapValidationFieldsToClassName(state, 'nos', 'nos-selector'))(NatureOfSuitOfAppellete)

const natureOfSuitOptions = {
  '1110': '1110 Insurance',
  '1120': '1120 Marine Contract Actions',
  '1130': '1130 Miller Act',
  '1140': '1140 Negotiable Instruments',
  '1150': '1150 Overpayments &amp; Enforc. of Judgments',
  '1151': '1151 Overpayments Under Medicare Act',
  '1152': '1152 Recovery of Defaulted Student Loans',
  '1153': '1153 Recovery of Ovrpmnts of Vet Benefit',
  '1190': '1190 Other Contract Actions',
  '1195': '1195 Contract Product Liability',
  '1196': '1196 Franchise',
  '1210': '1210 Land Condemnation',
  '1220': '1220 Foreclosure',
  '1230': '1230 Rent, Lease, Ejectment',
  '1240': '1240 Torts To Land',
  '1245': '1245 Tort Product Liability',
  '1290': '1290 Other Real Property Actions',
  '1340': '1340 Marine Personal Injury',
  '1350': '1350 Motor Vehicle',
  '1360': '1360 Other Personal Injury',
  '1370': '1370 Other Fraud',
  '1371': '1371 Truth in Lending',
  '1380': '1380 Other Personal Property Damage',
  '1385': '1385 Property Damage - Product Liability',
  '1410': '1410 Antitrust',
  '1422': '1422 Bankruptcy Appeals Rule 28 USC 158',
  '1423': '1423 Bankruptcy Withdraw 28 USC 157',
  '1430': '1430 Banks and Banking',
  '1440': '1440 Other Civil Rights',
  '1441': '1441 Civil Rights Voting',
  '1442': '1442 Civil Rights Jobs',
  '1443': '1443 Civil Rights Accommodations',
  '1444': '1444 Civil Rights Welfare',
  '1445': '1445 American w/Disab.Act-Empl',
  '1446': '1446 Americans w/Disab Act - Other',
  '1450': '1450 Interstate Commerce',
  '1470': '1470 Civil (RICO)',
  '1480': '1480 Consumer Credit',
  '1490': '1490 Cable Satellite/TV',
  '1610': '1610 Agricultural Acts',
  '1620': '1620 Food and Drugs Acts',
  '1625': '1625 Drug Related Seizure of Property',
  '1630': '1630 Liquor Laws',
  '1640': '1640 Railroad and Trucks',
  '1650': '1650 Airline Regulations',
  '1660': '1660 Occupational Safety/Health',
  '1690': '1690 Other Forfeiture and Penalty Suits',
  '1710': '1710 Fair Labor Standards Act',
  '1720': '1720 Labor/Management Relations Act',
  '1730': '1730 Report &amp; Disclosure',
  '1740': '1740 Railway Labor Act',
  '1790': '1790 Other Labor Litigation',
  '1791': '1791 Employee Retirement',
  '1830': '1830 Patent',
  '1840': '1840 Trademark',
  '1850': '1850 Securities, Commodities, Exchange',
  '1862': '1862 Black Lung',
  '1863': '1863 D.I.W.C./D.I.W.W.',
  '1870': '1870 Tax Suits',
  '1871': '1871 IRS 3rd Party Suits 26 USC 7609',
  '1890': '1890 Other Statutory Actions',
  '1891': '1891 Agricultural Acts',
  '1892': '1892 Economic Stabilization Act',
  '1893': '1893 Environmental Matters',
  '1894': '1894 Energy Allocation Act',
  '1950': '1950 Constitutionality of State Statutes',
  '1990': '1990 Other',
  '1999': '1999 Miscellaneous',
  '2110': '2110 Insurance',
  '2120': '2120 Marine Contract Actions',
  '2130': '2130 Miller Act',
  '2140': '2140 Negotiable Instruments',
  '2150': '2150 Ovrpmnts &amp; Enforcement of Judgments',
  '2151': '2151 Overpayments Under Medicare Act',
  '2152': '2152 Recovery of Defaulted Student Loans',
  '2153': '2153 Recovery Overpayment Vet Benefits',
  '2190': '2190 Other Contract Actions',
  '2195': '2195 Contract Product Liability',
  '2196': '2196 Franchise',
  '2210': '2210 Land Condemnation',
  '2220': '2220 Foreclosure',
  '2230': '2230 Rent, Lease, Ejectment',
  '2240': '2240 Torts to Land',
  '2245': '2245 Tort Product Liability',
  '2290': '2290 Other Real Property Actions',
  '2310': '2310 Airplane Personal Injury',
  '2315': '2315 Airplane Product Liability',
  '2320': '2320 Assault, Libel, and Slander',
  '2330': '2330 Federal Employers\' Liability',
  '2340': '2340 Marine Personal Injury',
  '2345': '2345 Marine - Product Liability',
  '2350': '2350 Motor Vehicle',
  '2355': '2355 Motor Vehicle Product Liability',
  '2360': '2360 Other Personal Injury',
  '2362': '2362 Medical Malpractice',
  '2365': '2365 Personal Injury - Product Liability',
  '2368': '2368 Asbestos Personal Injury-Product Liability',
  '2370': '2370 Other Fraud',
  '2371': '2371 Truth in Lending',
  '2380': '2380 Other Personal Property Damage',
  '2385': '2385 Property Damage-Product Liability',
  '2410': '2410 Antitrust',
  '2422': '2422 Bankruptcy Appeals Rule 28 USC 158',
  '2423': '2423 Bankruptcy Withdrawal 28 USC 157',
  '2430': '2430 Banks and Banking',
  '2440': '2440 Other Civil Rights',
  '2441': '2441 Civil Rights Voting',
  '2442': '2442 Civil Rights Jobs',
  '2443': '2443 Civil Rights Accommodations',
  '2444': '2444 Civil Rights Welfare',
  '2445': '2445 Americans w/Disab.Act-Empl',
  '2446': '2446 Americans w/Disab Act - Other',
  '2450': '2450 Interstate Commerce',
  '2460': '2460 Deportation',
  '2462': '2462 Naturalization Application',
  '2463': '2463 Habeas Corpus- Alien Detainee',
  '2465': '2465 Other Immigration Actions',
  '2480': '2480 Consumer Credit',
  '2490': '2490 Cable Satellite/TV',
  '2510': '2510 Prisoner Petitions - Vacate Sentence',
  '2530': '2530 Habeas Corpus',
  '2535': '2535 Habeas Corpus: Death Penalty',
  '2540': '2540 Prisoner Petitions - Mandamus &amp; Other',
  '2550': '2550 Prisoner - Civil Rights',
  '2555': '2555 Prison Condition',
  '2610': '2610 Agricultural Acts',
  '2620': '2620 Food and Drug Acts',
  '2625': '2625 Drug Related Seizure of Property',
  '2630': '2630 Liquor Laws',
  '2640': '2640 Railroad and Trucks',
  '2650': '2650 Airline Regulations',
  '2660': '2660 Occupational Safety/Health',
  '2690': '2690 Other Forfeiture and Penalty Suits',
  '2710': '2710 Fair Labor Standards Act',
  '2720': '2720 Labor Management Relations Act',
  '2730': '2730 Labor/Management Rept &amp; Disclsure',
  '2740': '2740 Railway Labor Act',
  '2790': '2790 Other Labor Litigation',
  '2791': '2791 Employee Retirement',
  '2810': '2810 Selective Service',
  '2830': '2830 Patent',
  '2850': '2850 Securities, Commodities, Exch.',
  '2860': '2860 Social Security',
  '2861': '2861 Medicare',
  '2862': '2862 Black Lung',
  '2863': '2863 D.I.W.C./D.I.W.W.',
  '2864': '2864 S.S.I.D.',
  '2865': '2865 R.S.I.',
  '2870': '2870 Tax Suits',
  '2871': '2871 IRS 3rd Party Suits 26 USC 7609',
  '2875': '2875 Customer Challenge 12 USC 3410',
  '2890': '2890 Other Statutory Actions',
  '2891': '2891 Agricultural Acts',
  '2892': '2892 Economic Stabilization Act',
  '2893': '2893 Environmental Matters',
  '2894': '2894 Energy Allocation Act',
  '2895': '2895 Freedom of Information Act of 1974',
  '2900': '2900 Appeal of Fee -Equal Access Justice',
  '2950': '2950 Constitutionality of State Statutes',
  '2990': '2990 Other',
  '2999': '2999 Miscellaneous',
  '3110': '3110 Insurance',
  '3120': '3120 Marine Contract Actions',
  '3130': '3130 Miller Act',
  '3140': '3140 Negotiable Instruments',
  '3150': '3150 Recovery of Overpayment of Benefits',
  '3151': '3151 Overpayments Under Medicare Act',
  '3160': '3160 Stockholders\' Suits',
  '3190': '3190 Other Contract Actions',
  '3196': '3196 Franchise',
  '3210': '3210 Land Condemnation',
  '3220': '3220 Foreclosure',
  '3230': '3230 Rent, Lease, Ejectment',
  '3240': '3240 Torts to Land',
  '3245': '3245 Tort Product Liability',
  '3290': '3290 Other Real Property Actions',
  '3310': '3310 Airplane Personal Injury',
  '3315': '3315 Airplane Product Liability',
  '3320': '3320 Assault, Libel, and Slander',
  '3330': '3330 Federal Employers\' Liability',
  '3340': '3340 Marine Personal Injury',
  '3345': '3345 Marine - Product Liability',
  '3350': '3350 Motor Vehicle Personal Injury',
  '3355': '3355 Motor Vehicle Product Liability',
  '3360': '3360 Other Personal Injury',
  '3365': '3365 Personal Injury - Product Liability',
  '3368': '3368 Asbestos Personal Injury - Product Liability',
  '3370': '3370 Other Fraud',
  '3371': '3371 Truth In Lending',
  '3380': '3380 Other Personal Property Damage',
  '3385': '3385 Property Damage - Product Liability',
  '3400': '3400 State Re-Apportionment',
  '3410': '3410 Antitrust',
  '3422': '3422 Bankruptcy Appeals Rule 28 USC 158',
  '3423': '3423 Bankruptcy Withdrawal 28 USC 157',
  '3430': '3430 Banks and Banking',
  '3440': '3440 Other Civil Rights',
  '3441': '3441 Civil Rights Voting',
  '3442': '3442 Civil Rights Jobs',
  '3443': '3443 Civil Rights Accommodations',
  '3444': '3444 Civil Rights Welfare',
  '3445': '3445 Americans with Disabilities Act - Empl',
  '3446': '3446 Americans with Disabilities Act - Other',
  '3450': '3450 Interstate Commerce',
  '3460': '3460 Deportation',
  '3470': '3470 Civil (RICO)',
  '3480': '3480 Consumer Credit',
  '3490': '3490 Cable Satellite/TV',
  '3530': '3530 Habeas Corpus',
  '3535': '3535 Habeas Corpus: Death Penalty',
  '3540': '3540 Prisoner Petitions-Mandamus &amp; Other',
  '3550': '3550 Prisoner - Civil Rights',
  '3555': '3555 Prison Condition',
  '3710': '3710 Fair Labor Standards Act',
  '3720': '3720 Labor/Management Relations Act',
  '3730': '3730 Report &amp; Disclosure',
  '3740': '3740 Railway Labor Act',
  '3790': '3790 Other Labor Litigation',
  '3791': '3791 Employee Retirement',
  '3810': '3810 Selective Service',
  '3820': '3820 Copyright',
  '3830': '3830 Patent',
  '3840': '3840 Trademark',
  '3850': '3850 Securities, Commodities, Exch.',
  '3890': '3890 Other Statutory Actions',
  '3891': '3891 Agricultural Acts',
  '3892': '3892 Economic Stabilization Act',
  '3893': '3893 Environmental Matters',
  '3894': '3894 Energy Allocation Act',
  '3895': '3895 Freedom of Information Act of 1974',
  '3950': '3950 Constitutionality of State Statutes',
  '3990': '3990 Other',
  '3999': '3999 Miscellaneous',
  '4110': '4110 Insurance',
  '4120': '4120 Marine Contract Actions',
  '4140': '4140 Negotiable Instruments',
  '4150': '4150 Overpayments &amp; Enforcement of Judgments',
  '4160': '4160 Stockholders Suits',
  '4190': '4190 Other Contract Actions',
  '4195': '4195 Contract Product Liability',
  '4196': '4196 Franchise',
  '4210': '4210 Land Condemnation',
  '4220': '4220 Foreclosure',
  '4230': '4230 Rent, Lease, Ejectment',
  '4240': '4240 Torts to Land',
  '4245': '4245 Tort Product Liability',
  '4290': '4290 Other Real Property Actions',
  '4310': '4310 Airplane Personal Injury',
  '4315': '4315 Airplane Product Liability',
  '4320': '4320 Assault, Libel, and Slander',
  '4340': '4340 Marine Personal Injury',
  '4345': '4345 Marine - Product Liability',
  '4350': '4350 Motor Vehicle Personal Injury',
  '4355': '4355 Motor Vehicle Product Liability',
  '4360': '4360 Other Personal Injury',
  '4362': '4362 Medical Malpractice',
  '4365': '4365 Personal Injury - Product Liability',
  '4368': '4368 Asbestos Personal Injury - Product Liability',
  '4370': '4370 Other Fraud',
  '4371': '4371 Truth in Lending',
  '4380': '4380 Other Personal Property Damage',
  '4385': '4385 Property Damage - Product Liability',
  '4440': '4440 Other Civil Rights',
  '4441': '4441 Civil Rights Voting',
  '4442': '4442 Civil Rights Jobs',
  '4443': '4443 Civil Rights Accommodations',
  '4444': '4444 Civil Rights Welfare',
  '4445': '4445 Americans with Disabilities Act - Empl',
  '4446': '4446 Americans with Disabilities Act - Other',
  '4470': '4470 Civil (RICO)',
  '4480': '4480 Consumer Credit',
  '4490': '4490 Cable Satellite/TV',
  '4555': '4555 Prisoner- Prison Condition',
  '4950': '4950 Constitutionality of State Statutes',
  '4990': '4990 Other',
  '4999': '4999 Miscellaneous',
  '5535': '5535 Habeas Corpus: Death Penalty',
  '5990': '5990 Other',
  '5992': '5992 Local Jurisdictional Appeal',
  'ZZZ': 'Other Nature of Suit'
};


/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/NatureOfSuitOfAppellete/NatureOfSuitOfAppellete.js
 **/